<template>
	<v-flex xs4 class="border-select">
		<v-layout wrap align-center justify-end>
			<v-flex xs2>
				<p>Ingresos</p>
				<span>${{ bookingsAmountTotal | round }}</span>
			</v-flex>
			<v-flex xs4>
				<p>Ocupación Actual</p>
				<span>{{ bookingsTotal }}</span>
			</v-flex>
		</v-layout>
	</v-flex>
</template>

<script>
	import { round } from '@/shared/filters';
	import mixin from '@/shared/mixins';

	function subsidiaryId(id) {
		this.loadBookingsTotal(id);
	}

	export default {
		name: 'amounts-component',
		filters: {
			round,
		},
		mixins: mixin,
		props: {
			subsidiaryId: {
				required: true,
				type: [Number, String],
			},
		},
		watch: {
			subsidiaryId,
		},
	};
</script>

<style lang="scss" scoped>
	p {
		color: map-get($colors, blue-title);
		font-family: map-get($fonts, regular);
		font-size: 10px;
		margin: 0px;
		text-transform: uppercase;
	}

	span {
		color: map-get($colors, default-skyblue);
		font-family: map-get($fonts, medium);
		font-size: 15px;
	}

	.border-select {
		border-right: 1px solid map-get($colors, border-radio);
		padding-right: 16px !important;
	}
</style>



// WEBPACK FOOTER //
// AmountsComponent.vue?7bc1bff4